import React from "react";

export const SectionLabel = ({ children, align = "left", testid }) => {
  const wrap =
    align === "center"
      ? "flex items-center justify-center"
      : "flex items-center";
  return (
    <div className={wrap} data-testid={testid}>
      <span className="eyebrow flex items-center">
        <span className="gold-rule" />
        {children}
      </span>
    </div>
  );
};

export default SectionLabel;
